import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Countdown from 'react-countdown';
import './Widget.css';

const Widget = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const bgParam = params.get('bg') || 'default';

  useEffect(() => {
    const protocol = window.location.protocol;
    const host = window.location.hostname === 'localhost' ? 'localhost:3001' : window.location.host;
    const url = `${protocol}//${host}/api/widget-ping`;
    const referrer = document.referrer || window.location.href;
    
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ referrer })
    }).catch(() => {});
  }, []);

  const releaseDate = new Date(2026, 10, 19, 0, 0, 0);

  const mainRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <div className="widget-main-completed">RELEASED</div>;
    }
    return (
      <div className="widget-countdown">
        <div className="widget-time-block">
          <span className="widget-time-val">{days}</span>
          <span className="widget-time-lbl">Days</span>
        </div>
        <div className="widget-time-block">
          <span className="widget-time-val">{hours}</span>
          <span className="widget-time-lbl">Hrs</span>
        </div>
        <div className="widget-time-block">
          <span className="widget-time-val">{minutes}</span>
          <span className="widget-time-lbl">Min</span>
        </div>
        <div className="widget-time-block">
          <span className="widget-time-val">{seconds}</span>
          <span className="widget-time-lbl">Sec</span>
        </div>
      </div>
    );
  };

  const getContainerStyle = () => {
    if (bgParam === 'transparent') {
      return { background: 'transparent', backgroundImage: 'none' };
    }
    if (bgParam === 'solid') {
      return { background: '#0a0814', backgroundImage: 'none' };
    }
    const bgName = bgParam === 'default' ? 'Official_Cover_Art_landscape.webp' : bgParam;
    return { backgroundImage: `url(${process.env.PUBLIC_URL}/img/backgrounds/${bgName})` };
  };

  const overlayStyle = bgParam === 'transparent' ? { background: 'transparent' } : {};

  return (
    <div className={`widget-container bg-${bgParam}`} style={getContainerStyle()}>
      <div className="widget-overlay" style={overlayStyle}></div>
      <div className="widget-content">
        <div className="widget-logo-container">
          <img 
            src="https://gtasixcountdown.com/img/icons/Grand_Theft_Auto_VI_logo_(with_gradient).svg.png" 
            alt="GTA VI" 
            className="widget-logo"
          />
        </div>
        
        <Countdown date={releaseDate} renderer={mainRenderer} />
        
        <div className="widget-release-lbl">NOVEMBER 2026</div>
      </div>
    </div>
  );
};

export default Widget;
